import { DOCUMENT_FILE_MIME_TYPE } from 'constants/file';

export const UPLOAD_FORM_DELIVERY_ACCEPTED_FILE_TYPES = [DOCUMENT_FILE_MIME_TYPE.PDF];
export const UploadFormDeliveryBundleStatus = {
  LOADING: 'loading',
  READY: 'ready',
  UNAVAILABLE: 'unavailable',
};
export const UPLOAD_FORM_DELIVERY_FILE_REQUIRED_MESSAGE = 'A PDF file is required';
export const UPLOAD_FORM_DELIVERY_BUNDLE_UNAVAILABLE_MESSAGE =
  'This document cannot be uploaded: the form bundle of this action was not found or has no document type. Check the form bundle and loan action configuration.';
